export const modalDescriptions = {
  airport: {
    title: '我们的机场接送服务包含什么？',
    subtitle: '✈️ 机场接送服务',
    image: '/img/modalDescription/airport.webp',
    imageAlt: '用于机场接送的汽车',
    ariaLabel: {
      orderButton: '前往机场接送预订表单',
      orderButtonText: '预订接送服务',
      closeButton: '关闭弹窗',
    },
    list: [
      '司机将在航站楼出口举牌迎接您。',
      '协助搬运行李。',
      '航班追踪（我们知道航班是否延误）。',
      '最多60分钟免费等待时间。',
      '豪华汽车（提供Wi-Fi、矿泉水、按需儿童座椅）。',
      '适用于往返瓦茨拉夫·哈维尔机场的路线。',
      '价格从30欧元起。',
    ],
    text: '我们的机场接送服务确保您的旅程开始或结束顺利安心。我们追踪您的航班并在到达区举牌迎接您。司机将协助搬运行李，并用配有Wi-Fi的豪华汽车将您直接送达目的地。我们提供首小时的免费等待时间，您无需担心航班延误。',
  },

  corporate: {
    title: '商务出行的理想解决方案',
    subtitle: '🧑‍💼 商务接送服务',
    image: '/img/modalDescription/corporate.webp',
    imageAlt: '为商务客户准备的高级轿车',
    ariaLabel: {
      orderButton: '前往商务接送预订表单',
      orderButtonText: '预订接送服务',
      closeButton: '关闭弹窗',
    },
    list: [
      '为企业客户提供服务。',
      '可与公司签署合同。',
      '每月账单及报表服务。',
      '司机着装正式，确保行程私密。',
      '提供商务级及以上车型。',
      '可用于会议、活动、代表团接送。',
      '可通过企业账户追踪行程。',
    ],
    text: '我们为重视舒适和准时的公司客户提供高端服务。在酒店、会议中心和机场之间的接送均由经验丰富的专业司机完成。支持签署合同与按月结算。确保您的员工安全准时到达目的地。',
  },

  personal: {
    title: '您的专属司机（按天、按周或按需）',
    subtitle: '🚗 专属司机服务',
    image: '/img/modalDescription/personal.webp',
    imageAlt: '配有豪华轿车的专属司机',
    ariaLabel: {
      orderButton: '前往专属司机预订表单',
      orderButtonText: '预订司机',
      closeButton: '关闭弹窗',
    },
    list: [
      '按小时或全天租用司机。',
      '城市出行、临时停车、等待时间均包含。',
      '豪华车型配备司机。',
      '私人出行、购物游、重要会议皆适用。',
      '适合游客、VIP客户、老年人。',
      '司机会说英语/捷克语。',
    ],
    text: '专属司机服务为您提供无忧自由出行体验。无论行程多复杂，司机全程陪同。您可选择购物游、商务会议或近郊出游。我们提供豪华座驾、专业服务和完全的隐私保障。',
  },

  vip: {
    title: '尊贵与舒适的极致体验',
    subtitle: '👑 VIP及豪华服务',
    image: '/img/modalDescription/vip.webp',
    imageAlt: '准备出行的VIP豪华车辆',
    ariaLabel: {
      orderButton: '前往VIP服务预订表单',
      orderButtonText: '预订VIP接送',
      closeButton: '关闭弹窗',
    },
    list: [
      '为每位客户量身定制服务。',
      '使用顶级豪华车型。',
      '司机穿着正式，拥有服务VIP宾客经验。',
      '完全保密的服务体验。',
      '附加选项：欢迎礼包、矿泉水、报纸等。',
      '适用于商务会面、外交访问、婚礼及社交活动。',
      '提供24/7客服与专属客户经理。',
    ],
    text: '专属司机服务为您提供无忧自由出行体验。无论行程多复杂，司机全程陪同。您可选择购物游、商务会议或近郊出游。我们提供豪华座驾、专业服务和完全的隐私保障。',
  },

  tours: {
    title: '舒适又愉快的旅行体验',
    subtitle: '🌍 旅游与观光服务',
    image: '/img/modalDescription/vip.webp',
    imageAlt: '用于欧洲旅游和观光的汽车',
    ariaLabel: {
      orderButton: '前往旅游/观光预订表单',
      orderButtonText: '预订行程',
      closeButton: '关闭弹窗',
    },
    list: [
      '提供个性化及团队旅游服务。',
      '可选择导游或仅司机服务。',
      '灵活路线：捷克及欧洲（卡罗维发利、维也纳、德累斯顿、慕尼黑等）。',
      '舒适汽车，配备空调、Wi-Fi、饮用水。',
      '提供拍照时间、购物停留、当地餐饮体验。',
      '包含旅游保险与途中支持服务。',
      '可通过在线表单进行预订。',
    ],
    text: '跟随我们探索欧洲，无忧旅行无压力。我们根据您的兴趣和需求组织个性化或团队旅行。可选择导游陪同，或享受专业司机提供的舒适出行。所有行程注重便利、安全与难忘的体验。',
  },
};
